import { ReparoApi } from './index';

/**
 * A PDF route fetched with the session's token, handed back as a blob URL.
 *
 * The API authenticates on an Authorization header, so a PDF route cannot be a plain link: a
 * window.open of it would arrive signed out and redirect to login, which in the middle of a
 * recall or a send reads as the system losing the record. Fetch it, then give the browser the
 * blob to open or save.
 *
 * Goes through ReparoApi so the request reaches the API host in production rather than the
 * frontend host, which answers any unknown path with the app shell and a 200 - a blank tab
 * when opened as a document. `route` is the path after /api/v1. The content type is set by
 * hand because a body stream carries none, and a typeless blob downloads instead of opening.
 */
export const fetchPdfObjectUrl = async (route: string): Promise<string> => {
    const body = await ReparoApi<ReadableStream<Uint8Array>>({
        method: 'GET',
        url: route,
        stream: true,
    });
    const blob = await new Response(body, {
        headers: { 'Content-Type': 'application/pdf' },
    }).blob();
    return URL.createObjectURL(blob);
};
